// ============================================================================
// Rechtstexte — Versionierung (docs/26 §9).
// Die kanonischen Texte liegen versioniert in docs/legal-archiv/; der SHA-256
// dort ist der Beweis-Anker jedes Annahme-Records (terms_acceptances).
// Neue Version = neue Archiv-Datei + neue Konstanten + Re-Consent-Entscheid.
// Der Contract-Test legal-archiv.contract.test.ts erzwingt, dass Hash und
// Archiv-Datei zusammenpassen.
// ============================================================================

/** Aktuelle AGB-Version — Referenz in Checkbox, Annahme-Record und /agb.
 *  v1.1 (Klassen-Team, Ziff. 5a): Re-Consent-Gate greift für Bestandskonten
 *  automatisch über hasCurrentAgbAcceptance. */
export const AGB_VERSION = '1.1';
/** Anzeige-Datum der AGB («Stand»). */
export const AGB_STAND = '11. August 2026';
/** Kanonische Archiv-Datei der aktuellen AGB (repo-relativ). */
export const AGB_ARCHIV_PATH = 'docs/legal-archiv/agb-v1.1.md';
/** SHA-256 (hex) der kanonischen Archiv-Datei — Beweis-Anker der Annahme. */
export const AGB_SHA256 = '45d62fa5233704e51798fdf7b9d31aa890593e9fdaf1fb5aaf5422e8a08f83e1';

/** Aktuelle Fassung der Datenschutzerklärung (Kenntnisnahme, keine Annahme).
 *  v2.1: Absatz Klassen-Team im Auftrags-Abschnitt.
 *  v2.2: Lernkontrollen-Anker, Stichproben/Nachbesserungen, Wochenrückblick
 *  fürs Kind (Vollständigkeits-Abgleich 18.08.2026, docs/26 §11).
 *  v2.3: Blick-Speicherung und Löschfrist, Redis-Caches; Zweitbackup eingestellt,
 *  Kontorollen, KI-Freigaben und Grenzen der Pseudonymisierung präzisiert.
 *  v2.4: Kern-Datenhaltung auf Elestio/Hetzner (Falkenstein, Deutschland),
 *  BorgBase-Sicherungen der Instanz, Supabase als befristete Rückfalloption;
 *  Zero Data Retention bei OpenAI vereinbart (30.09.2026) und eingestellt (13.10.2026).
 *  v2.5: Satz zur ausstehenden ZDR-Klärung im Abschnitt KI-Auswertungen entfernt (Berichtigung). */
export const DATENSCHUTZ_VERSION = '2.5';
export const DATENSCHUTZ_STAND = '15. Oktober 2026';
/** Kanonische Archiv-Datei der aktuellen Datenschutzerklärung (repo-relativ).
 *  Publikations-Anker: belegt, welche Fassung wann veröffentlicht war —
 *  es entstehen keine Annahme-Records (Entscheid 2026-08-28, docs/26 §9). */
export const DATENSCHUTZ_ARCHIV_PATH = 'docs/legal-archiv/datenschutz-v2.5.md';
/** SHA-256 (hex) der kanonischen Archiv-Datei (LF-normalisiert). */
export const DATENSCHUTZ_SHA256 = 'b7a0e265234a18839761971a9f084278798b27d1805e17db80b2bb7543a42363';

/**
 * Die 26 Kantone — Pflichtangabe bei der Registrierung (AGB Ziff. 1:
 * Checkpoint richtet sich nur an Lehrpersonen schweizerischer Schulträger;
 * zugleich tragende EU-AI-Act-Scope-Kontrolle, docs/33 §3/§8 — nicht ohne
 * Neubewertung lockern).
 */
export const KANTONE = [
  'Aargau', 'Appenzell Ausserrhoden', 'Appenzell Innerrhoden', 'Basel-Landschaft',
  'Basel-Stadt', 'Bern', 'Freiburg', 'Genf', 'Glarus', 'Graubünden', 'Jura',
  'Luzern', 'Neuenburg', 'Nidwalden', 'Obwalden', 'Schaffhausen', 'Schwyz',
  'Solothurn', 'St. Gallen', 'Tessin', 'Thurgau', 'Uri', 'Waadt', 'Wallis',
  'Zug', 'Zürich',
] as const;
export type Kanton = (typeof KANTONE)[number];
